<div class="warning">
   Resetting performance ratings will set the performance rating for all functions and tasks in your
   organization to 'No Value'. This change cannot be undone.
</div>
<button mat-raised-button color="warn" (click)="confirmReset()">Reset Performance Ratings</button>
